import { useQuery } from "react-query";
import axios from "axios";
import { USER_DETAILS } from "./utils/constants";


// queries
export const useUserById = (user_id, role, activeTab) => {
    return useQuery([USER_DETAILS, user_id], async () => {
        let res = await axios.get(`/userManagement/users/${user_id}?role=${role}&activeTab=${activeTab}`)
        return res.data
    }, {
        enabled: !!user_id
    })
}